import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Observable } from 'rxjs';

import config from '../../assets/config.json';

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        private http: HttpClient,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private fireAuth: AngularFireAuth) {
    }

    public loading = new BehaviorSubject(false);
    public message = new BehaviorSubject('');
    public session = new BehaviorSubject(null);
    public wpUser = new BehaviorSubject(null);
    public orders = new BehaviorSubject(null);
    public myProducts = new BehaviorSubject(null);
    public myContacts = new BehaviorSubject(null);
    public comments = new BehaviorSubject(null);
    public currentApplication = new BehaviorSubject(null);
    public refresh = new BehaviorSubject(null);

    public backUrls = {
        Deltagare: '/tabs/tab3'
    };

    public friendMapper = {};
    public kursLedare = {};

    // private url = 'https://öhlund.se';

    public Login(username: string, password: string) {
        this.loading.next(true);
        this.message.next('');

        const headers = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
        });
        const userData = `username=${username}&password=${password}`;

        return this.http.post(`${config.url}/wp-json/jwt-auth/v1/token`, userData, { headers })
            .toPromise().then(response => {

                // Hämta användaren från wordpress
                return this.GetUserFromSession(response).toPromise().then(user => {
                    console.log('OK');

                    // Logga in i appen
                    this.session.next(response);
                    localStorage.setItem('session', JSON.stringify(response));

                    const custom = user.simple_local_avatar !== undefined && user.simple_local_avatar !== null;
                    if (custom) {
                        console.log('Using custom avatar');
                    }
                    user.avatar_urls[48] = custom ? user.simple_local_avatar.full : user.avatar_urls[48];


                    this.wpUser.next(user);
                    localStorage.setItem('user', JSON.stringify(user));

                    return this.Refresh();
                },
                    _ => {
                        this.message.next('Något gick åt skogen');
                        this.loading.next(false);
                        return false;
                    }
                );

            },
                fail => {
                    let message = '';
                    switch (fail.error.data.status) {
                        case 403:
                            message = 'Fel användarnamn eller lösenord';
                            break;
                        default:
                            message = 'Något gick åt skogen';
                            break;
                    }
                    this.message.next(message);
                    this.loading.next(false);
                    return false;
                });
    }

    // public AllProductsExcept() {
    //     this.GetWooProducts();
    // }

    public Refresh(navigate: boolean = true): Promise<boolean> {
        const { returnUrl } = this.activatedRoute.snapshot.queryParams;

        // Load data
        return this.GetWooOrders()
            .then(_ => {
                this.orders.next(_);
                console.log('OK');
                return this.GetWooProducts({ category: config.category });
            })
            .then(_ => {
                this.myProducts.next(_);
                console.log('My products', _);
                console.log('OK');
                return _;
            })
            .then(_ => {

                const tjosan = [];
                _.map(p => {
                    console.log('Getting members for product', p.id);
                    tjosan.push(
                        this.GetWooOrdersForProduct(p.id).then(__ => {
                            const friends = [];
                            (__ as []).forEach(order => {
                                if (this.wpUser.getValue().id !== (order as any).customer_id) {
                                    friends.push((order as any).customer_id);

                                    // Create mapper for product <> friends
                                    if (this.friendMapper[(order as any).customer_id] === undefined) {
                                        this.friendMapper[(order as any).customer_id] = [];
                                    }
                                    this.friendMapper[(order as any).customer_id].push(p);
                                }
                            });
                            return friends;
                        })
                    );
                });

                return forkJoin(tjosan).toPromise();
            })
            .then(_ => {
                console.log('OK');
                if (_ === undefined) {
                    console.log('Found no friends');
                    return [];
                }
                if ((_[0] as any[]).length === 0) {
                    console.log('Found no friends');
                    return [];
                }
                return this.GetWooCustomers(Object.assign.apply(Array, [].concat(_))); //   [].concat(..._));
            }).then(_ => {
                console.log('OK');
                this.myContacts.next(_);
                return _;
            }).then(_ => {
                console.log('Fetching extra information');
                const ids = [];
                (_ as any[]).map(x => ids.push(x.id));
                return this.ListUsers(ids);
            }).then(_ => {
                console.log('OK');
                console.log('Applying extra information');
                const contacts = this.myContacts.getValue();
                const mycourses = this.myProducts.getValue();
                const session = this.session.getValue();
                const myUser = this.wpUser.getValue();

                // Kursledare)
                contacts.forEach(x => {
                    const kurser = [... new Set(this.friendMapper[x.id])] as any[];
                    const kursledare = [];
                    kurser.forEach(kurs => {
                        const attr = kurs.attributes.filter(x => x.name = 'kursledare');
                        if (attr.length === 1) {
                            attr[0].options.forEach(email => {
                                if (x.email === email) {
                                    
                                    const kled = { id: kurs.id, email, kurs };
                                    if (!kursledare.includes(klex => klex.id == kled.id && klex.email == kled.email)) {
                                        kursledare.push(kled);
                                    }

                                    const mykurs = mycourses.filter(m => m.id == kurs.id)[0];
                                    if (mykurs.kursledare === undefined) {
                                        mykurs.kursledare = [];
                                    }

                                    if (!mykurs.kursledare.includes(x)) {
                                        mykurs.kursledare.push(x);
                                    }
                                }
                            });
                        }
                    });

                    x.kursledare = kursledare;
                    x.deltagare = kurser;
                });

                // Add myself to kursledare if needed
                mycourses.forEach(kurs => {
                    const attr = kurs.attributes.filter(x => x.name = 'kursledare');
                    if (attr.length === 1) {
                        attr[0].options.forEach(email => {
                            if (session.user_email === email) {
                                kurs.kursledare.push(myUser);
                            }
                        });
                    }
                });

                // Custom avatars
                contacts.map(x => {
                    const source = (_ as any[]).find(d => d.id = x.id);
                    x.simple_local_avatar = source.simple_local_avatar !== undefined ? source.simple_local_avatar : null;
                    if (source.simple_local_avatar !== undefined && source.simple_local_avatar !== null) {
                        x.avatar_url = source.simple_local_avatar.full;
                    }
                });

                contacts.sort((a, b) => (b.kursledare.length ? 1 : -1) - (a.kursledare.length ? 1 : -1));

                this.myContacts.next(contacts);
                this.myProducts.next(mycourses);
                return _;
            }).then(_ => {
                console.log('Connecting to firebase');
                return this.fireAuth.signInAnonymously();
            }).then(_ => {
                console.log('OK');
                this.loading.next(false);
                this.message.next('');

                if (navigate) {
                    return this.router.navigate([returnUrl]);
                }

                return true;
            });
    }

    GetUserFromSession(session: any): Observable<any> {
        console.log('Loading session');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4',
            Authorization: `Bearer ${session.token}`
        });
        return this.http.get(`${config.url}/wp-json/wp/v2/users/me`, { headers: h });
    }

    Upload(formData: FormData, file: File): Promise<string> {
        console.log('Uploading', formData, file);

        return fetch(`${config.url}/wp-json/wp/v2/media`, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${this.session.getValue().token}`
            },
            body: formData
        }).then(response => response.text());
    }

    UpdateProfile(p: any) {
        const h = new HttpHeaders({
            // 'Content-Type': 'application/x-www-form-urlencoded',
            // Accept: 'application/vnd.vimeo.*+json;version=3.4',
            Authorization: `Bearer ${this.session.getValue().token}`
        });
        // return this.http.put(`${config.url}/wp-json/wp/v2/users/${this.wpUser.getValue().id}`, p , { headers: h }).toPromise();
        return this.http.put(`${config.url}/wp-json/wp/v2/users/me`, p, { headers: h })
            .toPromise()
            .then(_ => {
                this.wpUser.next(_);
                return _;
            });
    }

    ListUsers(p: any[]) {
        console.log('Loading contacts from WP');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4',
            Authorization: `Bearer ${this.session.getValue().token}`
        });
        // return this.http.put(`${config.url}/wp-json/wp/v2/users/${this.wpUser.getValue().id}`, p , { headers: h }).toPromise();
        if (p.length === 0) {
            p = [-100];
        }

        return this.http.get(`${config.url}/wp-json/wp/v2/users/?per_page=100`, { headers: h, params: { include: p.join(',') } })
            .toPromise().then(result => {
                const l = {};
                return new Promise((resolve, reject) => resolve((result as any[]).map(x => l[x.id] = x)));
            }).catch(error => this.Logout());
        // .then(_ => {
        //     console.log(_);
        //     this.wpUser.next(_);
        //     return _;
        // });
    }

    // GetOrders() {
    //     console.log('Loading orders');
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4',
    //         Authorization: `Bearer ${this.session.getValue().token}`
    //     });

    //     return this.http.get(`${config.url}/wp-json/wc/v3/orders/?customer=${this.wpUser.getValue().id}`, { headers: h })
    //         .toPromise()
    //         .then(_ => {
    //             this.orders.next(_);
    //             return _;
    //         });
    // }

    GetWooOrders() {
        console.log('Loading orders');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4'
        });

        const body = {
            // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
            // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
            consumer_key: config.consumer_key,
            consumer_secret: config.consumer_secret,
            cusomer: this.wpUser.getValue().id
        };

        return this.http.get(`/wc-api/v3/orders?filter[limit]=-1&filter[customer_id]=${this.wpUser.getValue().id}&filter[role]=all&consumer_key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
            { headers: h })
            .toPromise()
            .then((_: any) => {
                this.orders.next(_.orders);
                return _.orders;
            });
    }

    GetWooCustomers(customerIds: any[]) {
        console.log('Loading contacts');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4'
        });

        const body = {
            // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
            // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
            consumer_key: config.consumer_key,
            consumer_secret: config.consumer_secret,
            cusomer: this.wpUser.getValue().id
        };

        const customers = customerIds.join(',');

        return this.http.get(`/wp-json/wc/v3/customers/?per_page=100&include=${customers}&role=all&consumer_key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
            { headers: h })
            .toPromise();
        // .then(_ => {
        //     this.myContacts.next(_);
        //     return _;
        // })
    }

    GetWooOrdersForProduct(productId: any) {
        console.log('Loading orders for product', productId);
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4'
        });

        const body = {
            // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
            // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
            consumer_key: config.consumer_key,
            consumer_secret: config.consumer_secret,
            cusomer: this.wpUser.getValue().id
        };

        return this.http.get(`/wp-json/wc/v3/orders/?per_page=100&product=${productId}&consumer_key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
            { headers: h })
            .toPromise()
            .then(_ => {
                return _;
            });
    }

    GetAllWooProducts(p: any = {}) {
        console.log('Loading courses');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4'
        });

        const body = {
            // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
            // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
            consumer_key: config.consumer_key,
            consumer_secret: config.consumer_secret,
            cusomer: this.wpUser.getValue().id
        };

        const products = {};
        this.orders.getValue().forEach(order => {
            order.line_items.forEach(item => {
                products[item.product_id] = true;
            });
        });

        return this.http.get(`/wc-api/v3/products?filter[limit]=-1&consumer_key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
            { headers: h, params: p })
            .toPromise()
            .then((allProducts: any) => {
                let filteredProducts = [];

                allProducts.products.filter(product => product.downloads.length > 0)
                    .forEach(element => {
                        if (products[element.id]) {
                            element.downloads.forEach(download => {
                                if (download.file.includes('video')) {
                                    element.downloads = [download];
                                    filteredProducts.push(element);
                                }
                            });
                        }
                    });

                return filteredProducts;
            });
    }

    GetWooProducts(p: any = {}) {
        console.log('Loading courses');
        const h = new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded',
            Accept: 'application/vnd.vimeo.*+json;version=3.4'
        });

        const body = {
            // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
            // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
            consumer_key: config.consumer_key,
            consumer_secret: config.consumer_secret,
            cusomer: this.wpUser.getValue().id
        };

        const products = {};
        this.orders.getValue().forEach(order => {
            order.line_items.forEach(item => {
                products[item.product_id] = true;
            });
        });

        return this.http.get(`/wc-api/v3/products?filter[limit]=-1&filter[category]=${p.category || ''}&consumer_key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
            { headers: h, params: p })
            .toPromise()
            .then((allProducts: any) => {
                const filteredProducts = (allProducts.products as any[]).filter(product => products[product.id] !== undefined);
                this.myProducts.next(filteredProducts);
                return filteredProducts;
            });
    }

    // GetProducts() {
    //     console.log('Loading courses');
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4',
    //         Authorization: `Bearer ${this.session.getValue().token}`
    //     });

    //     const products = {};
    //     this.orders.getValue().forEach(order => {
    //         order.line_items.forEach(item => {
    //             products[item.product_id] = true;
    //         });
    //     });

    //     return this.http.get(`${config.url}/wp-json/wc/v3/products`, { headers: h })
    //         .toPromise()
    //         .then(allProducts => {
    //             const filteredProducts = (allProducts as any[]).filter(p => products[p.id] !== undefined);

    //             this.myProducts.next(filteredProducts);
    //             return filteredProducts;
    //         });
    // }

    // GetComments(post: any) {
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4',
    //         Authorization: `Bearer ${this.session.getValue().token}`
    //     });



    //     return this.http.get(`${config.url}/wp-json/wp/v2/comments?post=${post}`, { headers: h })
    //         .toPromise()
    //         .then(_ => {
    //             this.comments.next(_);
    //             // console.log(_);
    //             return _;
    //         });
    // }

    // GetWooComments(post: any) {
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4'
    //     });

    //     const body = {
    //         // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
    //         // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
    //         consumer_key: config.consumer_key,
    //         consumer_secret: config.consumer_secret,
    //         cusomer: this.wpUser.getValue().id
    //     };

    //     return this.http.get(`${config.url}/wp-json/wc/v3/products/reviews?product=${post}&orderby=date&status=trash&consumer_
    // key=${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
    //         { headers: h })
    //         .toPromise()
    //         .then(_ => {
    //             this.comments.next(_);
    //             // console.log(_);
    //             return _;
    //         });
    // }

    // PutComment(postId: any, message: string) {
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4',
    //         Authorization: `Bearer ${this.session.getValue().token}`
    //     });

    //     const commentData = {
    //         author: this.wpUser.getValue().id,
    //         content: message,
    //         post: postId,
    //         status: 'trash'
    //     };

    //     return this.http.post(`${config.url}/wp-json/wp/v2/comments`, commentData, { headers: h }).toPromise()
    // .then(_ => console.log('wassah', _));
    // }

    // PutReview(postId: any, message: string) {
    //     const h = new HttpHeaders({
    //         'Content-Type': 'application/x-www-form-urlencoded',
    //         Accept: 'application/vnd.vimeo.*+json;version=3.4'
    //     });

    //     const body = {
    //         // consumer_key: 'ck_d5dc4b34653d6c2700c2e4a4999f14317909d376',
    //         // consumer_secret: 'cs_77293cb7a128b95c0ad64b448565c186073f93fd',
    //         consumer_key: config.consumer_key,
    //         consumer_secret: config.consumer_secret,
    //         cusomer: this.wpUser.getValue().id
    //     };

    //     // console.log('user', this.session.getValue());

    //     const commentData = {
    //         reviewer: this.wpUser.getValue().name,
    //         review: message,
    //         product_id: postId,
    //         reviewer_email: this.session.getValue().user_email,
    //         status: 'trash'
    //     };

    //     return this.http.post(`${config.url}/wp-json/wc/v3/products/reviews?consumer_key=
    // ${body.consumer_key}&consumer_secret=${body.consumer_secret}`,
    //         commentData, { headers: h })
    //         .toPromise()
    //         .then(_ => console.log('wassah', _));
    // }

    Logout() {
        localStorage.removeItem('session');
        localStorage.removeItem('user');
        this.wpUser.next(null);
        this.session.next(null);
        this.orders.next(null);
        this.myProducts.next(null);
        this.myContacts.next(null);
        this.comments.next(null);
        this.friendMapper = {};
        this.message.next('');
        this.comments.next(null);

        this.router.navigate(['']);
    }
}
